<template>
    <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;  background-color: white">
        <v-layout column style="background-color: white">
            <v-flex>
                <v-card id="faultsList">
                    <v-card-title primary class="title" style="height:5%;">
                        <div style="width: 100%; display: flex; height: 100%; position: relative;">
                            <span>Fault list</span>
                            <a id="listToggle" href="#" style="height:24px; position: absolute; left: 97%;" @click="toggleList">
                                <i :ref="'listToggleIcon'" class="material-icons">keyboard_arrow_down</i>
                            </a>
                        </div>
                    </v-card-title>
                    <v-card-text id="faultSlideHolder" style="height:90%;">
                        <v-layout column fill-height style="overflow:auto;">
                            <div id="fault-slides" class="slides" v-on:scroll="onSlideScroll">
                                <div class="slide" v-for="fault in enginefaults" :key="fault">
                                    <FaultCard v-on:faultChange="selFaultChange" v-bind:currentFault="fault" v-bind:kpi="kpi" v-bind:selFaultId="selectedFaultId"/>
                                </div>
                            </div>
                        </v-layout>
                        <v-layout row v-if="enginefaults.length > 1" style="padding-top: 5px;">
                            <div style="width: 50%; text-align: center;">
                                <a href="#" @click="slideBackward('fault-slides')" :class="'slider-arrows ' + ((reached_end == 0) ? 'disabled' : '')">
                                    <i class="material-icons">chevron_left</i>
                                </a>
                            </div>
                            <div style="width: 50%; text-align: center;">
                                <a href="#" @click="slideForward('fault-slides')" :class="'slider-arrows ' + ((reached_end == 1) ? 'disabled' : '')">
                                    <i class="material-icons">chevron_right</i>
                                </a>
                            </div>
                        </v-layout>
                        <div v-if="enginefaults.length < 1" class="title" style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:rgb(219,219,219);">No Faults Detected</div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex style="background-color: white; max-height: 80% !important; overflow-y: scroll !important;">
                <v-tabs v-model="active" slider-color="rgb(51,82,128)" style="height:100%;width:100%;">
                    <v-tab v-for="title in tabTitles" :key="title" ripple active-class='activeTab' style="text-transform:none;color:rgb(192,192,192);">
                        <span>{{title}}</span>
                    </v-tab>
                    <v-tab-item class="tabItem">
                        <EngineFaultsData v-bind:fault="selFault" v-bind:active="tabActive[0]"/>
                    </v-tab-item>
                    <v-tab-item class="tabItem">
                        <EngineFaultsDetails v-bind:fault="selFault" v-bind:active="tabActive[1]"/>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EngineFaultsData from "./EngineFaultsData"
    import EngineFaultsDetails from "./EngineFaultsDetails"
    import FaultCard from '../controls/FaultCard'
    import {globalStore, vessels} from "../main.js"
    import axios from 'axios';

    export default {
        name: 'EngineFaults',
        components: {
            EngineFaultsData,
            EngineFaultsDetails,
            FaultCard
        },
        props: {},
        data() {
            return {
                active: parseInt(this.$route.query.tab),
                tabTitles: ['Fault Data', 'Details'],
                kpi: {},
                selectedFaultId: -1,
                tabActive: [true, false],
                showDialog: false,
                ticketModels: {},
                profileFields: ['displayName', 'email'],
                labels: ['Username', 'Email', 'Title'],
                reached_end:0
            }
        },
        created() {
            this.tabActive[parseInt(this.$route.query.tab)] = true;

            for (let i = 0; i < this.profileFields.length; i++) {
                this.ticketModels[this.labels[i]] = globalStore.userProfile[this.profileFields[i]];
            }

            this.ticketModels['Type'] = ['Support'];
            this.ticketModels['Message'] = '';
            this.ticketModels['Title'] = '';
        },
        mounted() {
            if('id' in this.$route.params) {
                this.selectedFaultId = this.$route.params.id;
            } else if (this.enginefaults.length > 0) {
                this.selectedFaultId = this.enginefaults[0].Id;
            }

            setTimeout(() => {
                this.dismishNotification();
            }, 250);
        },
        methods: {
            selFaultChange(event) {
                this.selectedFaultId = event;
            },
            sendTicket() {
                var bodyFormData = new FormData();
                bodyFormData.set("name", this.ticketModels['Username']);
                bodyFormData.set("from", 'customer@wingd.com');//this.ticketModels['Email'] );
                bodyFormData.set("type", "1");
                bodyFormData.set("vessel", globalStore.selectedVessel);
                bodyFormData.set("engine", 'W-6X72');//'X-72' );
                bodyFormData.set("subject", this.ticketModels['Title']);
                bodyFormData.set("reply", this.ticketModels['Message']);
                bodyFormData.set("component", this.selFault['subComponent']);
                bodyFormData.set("subsystem", this.selFault['component']);
                bodyFormData.set("id", this.selFault['id']);

                axios({
                    method: 'post',
                    url: 'http://wingdservice.propulsionanalytics.com' + '/en/customer/create-ticket/',
                    data: bodyFormData,
                    config: {headers: {'Content-Type': 'multipart/form-data'}}
                })
                    .then(function (response) {
                        //handle success
                    })
                    .catch(function (error) {
                    });

                this.showDialog = false;
            },
            cancelDialog() {
                this.showDialog = false;
            },
            slideBackward(holderID) {
                var slider = document.getElementById(holderID),
                    slides = slider.querySelectorAll('.slide');

                slider.scrollLeft -= slides[0].clientWidth;
            },
            slideForward(holderID) {
                var slider = document.getElementById(holderID),
                    slides = slider.querySelectorAll('.slide');

                slider.scrollLeft += slides[0].clientWidth;
            },
            onSlideScroll() {
                var slider = document.getElementsByClassName('slides')[0],
                    slides = slider.querySelectorAll('.slide');

                if (slider.scrollLeft == 0) {
                    this.reached_end = 0;
                } else if (slider.scrollLeft >= (slider.clientWidth * (slides.length - 1))) {
                    this.reached_end = 1;
                } else {
                    this.reached_end = -1;
                }
            },
            toggleList() {
                var list = document.getElementById('faultsList');

                if (list.classList.contains('expanded')) {
                    list.classList.remove('expanded')
                } else {
                    list.classList.add('expanded')
                }

                if (this.$refs['listToggleIcon'].textContent == 'keyboard_arrow_down') {
                    this.$refs['listToggleIcon'].textContent = 'keyboard_arrow_up'
                } else {
                    this.$refs['listToggleIcon'].textContent = 'keyboard_arrow_down'
                }
            },
            dismishNotification () {
                if (globalStore.notificationId != null) {
                    axios.post(globalStore.config.api_location + '/notifications/dismish/' + globalStore.notificationId, {}, {headers:{Authorization: globalStore.auth_token}}).then((response) => {
                        globalStore.notificationId = null;
                        globalStore.alerts = response.data.data;
                    }).catch(() => {
                        globalStore.notificationId = null;
                    });
                }
            }
        },
        computed: {
            selFault: function () {
                var selected = this.enginefaults.filter(function (item) {
                    return item.Id == this.selectedFaultId;
                }, this);

                return selected[0];
            },
            enginefaults: function () {
                return globalStore.faults;
            },
            notificationId: function () {
                return globalStore.notificationId;
            }
        },
        watch: {
            active: function () {
                for (let i = 0; i < this.tabActive.length; i++) {
                    if (i == this.active)
                        this.tabActive[i] = true;
                    else
                        this.tabActive[i] = false;
                }
            },
            showDialog: function () {
                if (this.showDialog == true) {
                    this.ticketModels['Title'] = this.selFault.fault;
                }
            },
            currentFaults: function () {
                if (this.currentFaults.length > 0) {
                    this.selectedFaultId = this.currentFaults[0].Id;
                }
            },
            notificationId: function () {
                if (globalStore.notificationId != null) {
                    this.dismishNotification();
                }
            }
        }
    }
</script>

<style scoped>
    .tabItem {
        /*height: calc(100vh - 157px);*/
        height: 600px;
        background-color: white;
    }

    .slides {
        display: -webkit-box;
        display: flex;

        overflow-x: auto;
        -ms-scroll-snap-type: x mandatory;
        scroll-snap-type: x mandatory;

        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
    }

    .slides > div {
        width: 100%;
        scroll-snap-align: start;
        flex-shrink: 0;
        -webkit-transform-origin: center center;
        transform-origin: center center;
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: -webkit-transform 0.5s;
        transition: -webkit-transform 0.5s;
        transition: transform 0.5s;
        transition: transform 0.5s, -webkit-transform 0.5s;
        position: relative;

        display: -webkit-box;

        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
    }
</style>

<style>
    #fault-slides .hoverCard {
        width: 100% !important;
        height: 100% !important;
    }

    #fault-slides .slide {
        /*width: 100% !important;*/
        height: 100% !important;
    }

    .slider-arrows.disabled {
        color: lightgray;
    }

    #listToggle {
        display: none;
    }

    @media screen and (orientation:landscape) {
        #listToggle {
            display: initial;
        }

        #faultSlideHolder {
            padding: 0;
            max-height: 0 !important;
            overflow-y: hidden;
        }

        .v-card.expanded #faultSlideHolder {
            padding: 16px;
            max-height: 100% !important;
        }

        .v-card.expanded #faultSlideHolder, #faultSlideHolder {
            transition: max-height 100ms;
        }
    }
</style>
